import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { EmployeeRegistrationService } from '../../Model/EmployeeRegistration/employee-registration.service';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { NgbCollapse, NgbDropdownModule, NgbModal, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../../Model/Combo/combo.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { RegisterExcelFilterComponent } from '../RegisterExcelFilter/register-excel-filter/register-excel-filter.component';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { response } from 'express';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [CommonModule, RouterModule, DataTablesModule, NgbProgressbarModule, FormsModule, NgbDropdownModule, LoaderComponent, NgbCollapse, NgSelectModule],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent {
  isDisabled: boolean = false;
  isGDisabled: boolean = false;
  stars = [0, 1, 2, 3, 4] as any;
  EmployeeData = [] as any;
  FilterColumns = [] as any;
  isCollapsed = true;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  Filter = {
    SelectType: 'Search',
    IsDraft: true,
    ListType: 1,
    EmployeeCode: null,
    EmployeeOldCode: null,
    EmpName: null,
    BranchName: null,
    Category: '',
    Ess_CustomSearchFilterId: null,
    FilterValue: null,
  }
  exportProgress: number | null = null;
  dtoptions: DataTables.Settings = {};
  constructor(
    private route: ActivatedRoute,
    private employeeRegistration: EmployeeRegistrationService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private combo: ComboService,
    private session: SessionService,
    private download: DownloadSampleService,
    private toast: ToastService,
    private modalService: NgbModal,
    private router: Router,
  ) {
    this.common.getPageRights();
    this.Filter.Category = this.router.url.split('/')[3];
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.GetData();
    this.ComboLoad('CustomSearch');
    this.common.CheckExpiry();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  setSelectType(type: number) {
    this.Filter.ListType = type;
    this.GetData();
  }

  // GetData() {
  //   this.isDisabled = true;
  //   if (this.Filter.ListType == 1 || this.Filter.ListType == 2) {
  //     this.Filter.TabName = 'Search';

  //   } else if (this.Filter.ListType == 3) {
  //     this.Filter.TabName = 'PreOnBoarding';
  //     console.log(this.Filter.TabName);
  //   }

  //   if (this.Filter.ListType == 1) {
  //     this.Filter.IsDaft = false;
  //   } else {
  //     this.Filter.IsDaft = true;
  //   }
  //   this.employeeRegistration.EmpRegSelectGetData({ 'SelectType': this.Filter.TabName, 'EmpMasterId': 0, 'IsDraft': this.Filter.IsDaft }).subscribe({
  //     next: (response) => {
  //       this.EmployeeData = Object.values(response.Table)
  //       this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //         dtInstance.destroy();
  //         this.dtTrigger.next(null);
  //       });
  //       this.isDisabled = false;
  //     },
  //     complete: () => { },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  GetData() {
    this.isDisabled = true;
    this.isGDisabled = true;
    if (this.Filter.ListType == 1) {
      this.Filter.IsDraft = false;
    } else {
      this.Filter.IsDraft = true;
    }
    this.employeeRegistration.ESS_EmpRegistration_SearchGet(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.EmployeeData = Object.values(response.Table)
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        } else {
          this.EmployeeData = Object.values([])
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.isDisabled = false;
        this.isGDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
        this.isGDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype, 'BranchId': 0, 'ClientId': 0, 'SiteId': 0, 'DesignationId': 0, 'EmpType': this.Filter.Category, 'StateId': 0,
      'DistrictId': 0,
      'EmpMasterID': 0
    }).subscribe({
      next: (response) => {
        if (Combotype == 'CustomSearch') {
          if (response.ComboLoad) {
            this.FilterColumns = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_GetEmployeeDumpReport(result: any) {
    this.isDisabled = true;
    this.employeeRegistration.ESS_GetEmployeeDump_newReport(result).subscribe({
      next: async (response: any) => {
        this.download.exportToExcelWithProgress(response.Table, "Onbording");
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_GetEmployeeDumpFilter() {
    const modalRef = this.modalService.open(RegisterExcelFilterComponent, { size: 'lg', backdrop: 'static', });
    modalRef.componentInstance.EmpType = this.Filter.Category;
    modalRef.result.then((result: any) => {
      if (result != null && result != undefined) {
        this.ESS_GetEmployeeDumpReport(result);
      }
    });
  }

  DeleteDraft(element: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to Delete?'
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsDelete) {
        if (result) {
          this.isDisabled = true;
          this.employeeRegistration.ESS_EmpDraftClear({ SelectType: 'D', EmpMasterId: element.EmpMasterId }).subscribe({
            next: (response) => {
              if (response.Error_Code == '723') {
                this.isDisabled = false
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.setSelectType(2)
                  }
                });
              }
              else {
                this.isDisabled = false;
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            }
          })
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
      this.isDisabled = false
    });
  }

  async FinalSave(element: any) {
    await this.common.getPageRights();
    if (this.common.PageRight.IsEdit) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to final save?';
      modalRef.result.then((result: any) => {
        if (result) {
          this.isDisabled = true;
          this.employeeRegistration.EmployeeFinalSubmit({ EmpMasterId: element.EmpMasterId, SelectType: 'I', SelectType1: 'Add', UserMasterId: this.session.GetUserDetails().UserId, TableName: 'EmployeeMaster', IsDraft: this.Filter.IsDraft, EmpType: element.EmpType }).subscribe({
            next: (response) => {
              if (response.Error_Code == "15") {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.setSelectType(2);
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => {
              this.isDisabled = false;
            },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      });
    } else {
      const modalRef = this.modalService.open(AlertWarningComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = this.tooltip.Message.UnauthorizedMessage;
      modalRef.result.then((result: any) => { });
    }
  }

  async Rejoin(element: any) {
    await this.common.getPageRights();
    if (this.common.PageRight.IsEdit) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to rejoin?';
      modalRef.result.then((result: any) => {
        if (result) {
          this.isDisabled = true;
          this.employeeRegistration.ESS_EmployeeRejoinProcess({ SelectType: 'RE', EmpMasterId: element.EmpMasterId, IsDraft: this.Filter.IsDraft }).subscribe({
            next: (response) => {
              if (response.Error_Code == '879') {
                this.isDisabled = false
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.router.navigate(['onboarding/register/add/' + response.NewEmpId + '/' + true]);
                  }
                });
              }
              else {
                this.isDisabled = false;
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            }
          })
        }
      });
    }
  }
}
